import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * Modal présentationnelle (titre + actions). Rendue dans document.body.
 * Pour les confirmations, le flux existant utilise ConfirmDialog + react-confirm.
 */
const Modal = ({
  open,
  onClose,
  closeOnOverlayClick = true,
  title,
  children,
  footer,
  className = '',
  overlayClassName = '',
}) => {
  if (!open) return null;

  const modalTree = (
    <div
      className={`tsk-ui-modal-overlay${overlayClassName ? ` ${overlayClassName}` : ''}`}
      role="presentation"
      onClick={(e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget && onClose) {
          onClose();
        }
      }}
    >
      <div
        className={`tsk-ui-modal-surface${className ? ` ${className}` : ''}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {title ? (
          <div className="tsk-ui-modal__title" role="heading" aria-level={2}>
            {title}
          </div>
        ) : null}
        <div className="tsk-ui-modal__body">{children}</div>
        {footer ? <div className="tsk-ui-modal__actions">{footer}</div> : null}
      </div>
    </div>
  );

  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(modalTree, document.body);
  }

  return modalTree;
};

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  closeOnOverlayClick: PropTypes.bool,
  title: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
};

export default Modal;
